export default {
  // created() {
  //   this.$container.eventBus.on('toggleModal', (modal) => {
  //     if (modal) {
  //       this.$store.dispatch('pushModal', modal).catch(console.error);
  //     } else {
  //       this.$store.dispatch('popModal').catch(console.error);
  //     }
  //   });
  // },
  computed: {
    modalOpen() {
      return this.$store.state.tmp.modalStack.length > 0;
    },
  },
  methods: {
    closeTopModal() {
      this.$container.eventBus.emit(
        'closeModal',
        this.$store.state.tmp.modalStack[this.$store.state.tmp.modalStack.length - 1],
      );
    },
  },
};
